import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleIdCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPeopleIdCard2"><Path fillRule="evenodd" clipRule="evenodd" d="M8 8H16V4H20V22H4V4H8V8ZM12 16.5C9.85841 16.5 8.06606 17.996 7.61133 20H16.3887C15.9339 17.996 14.1416 16.5 12 16.5ZM12 9.75C10.6193 9.75 9.5 10.8693 9.5 12.25C9.5 13.6307 10.6193 14.75 12 14.75C13.3807 14.75 14.5 13.6307 14.5 12.25C14.5 10.8693 13.3807 9.75 12 9.75Z" fill="currentColor"/><Path d="M14 6H10V2H14V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeopleIdCard2;
